function isValidId(id) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(id);
}

function isValidPassword(password) {
    const passwordRegex = new RegExp("^[a-zA-Z0-9!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>/?~`]{8,20}$");
    return passwordRegex.test(password);
}


function createGradient(context, colorStart, colorEnd) {
    const chart = context.chart;
    const ctx = chart.ctx;
    const yValue = context.raw;
    const yPosition = chart.scales.y.getPixelForValue(yValue);


    if (isNaN(yPosition) || yPosition === Infinity || yPosition === -Infinity) {
        return colorStart;
    }

    const gradient = ctx.createLinearGradient(0, yPosition, 0, chart.scales.y.getPixelForValue(0));
    gradient.addColorStop(0, colorStart);
    gradient.addColorStop(1, colorEnd);
    return gradient;
}

export { isValidId, isValidPassword, createGradient };


